module.exports = {"130826001":"新丰路街道","130826100":"大阁镇","130826101":"大滩镇","130826102":"鱼儿山镇","130826103":"土城镇","130826104":"黄旗镇","130826105":"凤山镇","130826106":"波罗诺镇","130826107":"黑山咀镇","130826108":"天桥镇","130826109":"胡麻营镇","130826110":"将军营镇","130826200":"万胜永乡","130826201":"四岔口乡","130826202":"苏家店乡","130826203":"外沟门乡","130826204":"草原乡","130826205":"窟窿山乡","130826206":"小坝子乡","130826207":"五道营乡","130826209":"选将营乡","130826210":"西官营乡","130826211":"王营乡","130826212":"北头营乡","130826214":"石人沟乡","130826215":"汤河乡","130826216":"杨木栅子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130826.json
// module id = 295
// module chunks = 0